<template lang="pug">
.colorbar-careers-testimonials
  .row.testimonials
    .outer-image-wrap.xs-12.md-6
      .image-wrap
        responsive-image(:media-obj="testimonialImage" xs-aspect-key="3x2")
    .testimony-wrap.xs-12.md-6
      .testimonyContainer
        .testimonies-wrap
          img.quote-img(:src="quoteImage.url" :alt="quoteImage.alt_text")
          slick.testimonies(:slides-to-show="1" :slides-to-scroll="1" :autoplay="true" :arrows="false" :dots="true")
            .testimony(v-for="testimony in testimonies" :key="testimony.name")
              .inner-testimony
                p.the-quote.f-primary.xs-f-xsmall.md-f-small {{ testimony.quote }}
                p.upper.xs-f-large.name {{ testimony.name }}
                p.title.upper.f-primary.xs-f-xsmall {{testimony.title}}
</template>

<script>
  export default {

    name: 'HcbCareersTestimonials',

    props: {
      testimonialImage: {
        type: Object,
        default() {
          return {};
        }
      },
      quoteImage: {
        type: Object,
        default() {
          return {};
        }
      },
      testimonies: {
        type: Array,
        default() {
          return [];
        }
      }
    }
  };
</script>

<style lang="stylus" scoped>
.colorbar-careers-testimonials
  margin-bottom 30px
  
  .testimonials
    display block
    max-width 100%
    overflow hidden
    margin-bottom -3px
          
    .outer-image-wrap
      padding-left 25%
      overflow hidden

      @media mq-tablet-less
        padding-left 0%

    .image-wrap
      position relative
      display block
      margin-left -125%

      @media mq-desktop-less
        margin-left -175%

      @media mq-tablet-less
        margin-left 0%

      .responsive-image
        @media mq-tablet-less
          margin-left 0%
          transform unset
        
        :deep(img)
          height 100%
          width unset
          max-height 802px
          
          @media mq-tablet-less
            width 100%
            display block
            height unset

    .testimony-wrap
      padding-right 7%
      padding-left 7%

      @media mq-desktop-plus
        padding-right 13%
      
      @media mq-tablet
        padding-right 5%
        padding-left 5%

      @media mq-tablet-less
        padding-left 2%
        padding-right 2%
        padding-bottom 5%

      .testimonyContainer
        transform translateY(50%)
        
        @media mq-desktop-less
          transform unset

        @media mq-tablet-less
          transform unset
          padding 2%
                  
        .testimonies-wrap
          transform translateY(-25%)

          @media mq-desktop-less
            transform unset
            
          .quote-img
            height 80px
            
            @media mq-tablet-less
              height 60px
              margin-left 50%
              transform translateX(-30px)

          .testimonies
            :deep(.slick-dots)
              justify-content space-around
              transform translate(-50%, 50%)
              margin-right -50%
              left 50%
          
              li
                button
                  font-size 0
                  border none
                  margin -6px
                
                  &:before
                    width 8px
                    height 8px
                    border 0px solid #ffffff
                    border-radius 100px
                    opacity 1
                    content ''
                    background-color #c4c4c4
          
                  &:focus
                    outline none
          
              .slick-active button
                &:before
                  background-color #600057
      
        .testimony
          .inner-testimony
            .the-quote
              color brand-color-3
              margin-bottom 2.625rem

            .name
              font-family "Kapra-Regular", sans-serif
              color brand-color-3

            .title
              font-size 1rem
              line-height 30px
              color color-mister-darker-gray

              opacity .6
              letter-spacing 0.58px

          @media (max-width 1024px)
            .the-quote,
            .name,
            .title
              text-align center
</style>